// extracted by mini-css-extract-plugin
export default {"label":"DataView_label__8xMmd","value":"DataView_value__vniHf","card":"DataView_card__23kby"};